module.exports = __webpack_public_path__ + "img/icon-message-arrow.18d36d0c.svg";